import styled from 'styled-components'
import { HEADER_HEIGHT } from '../../templates/style'

export const StyledMobilMenu = styled.div<{ open: boolean }>`
  position: fixed;
  z-index: 9999;
  top: ${HEADER_HEIGHT};
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: calc(100% - 5rem);
  background-color: ${props => props.theme.colors.white[500]};
  opacity: ${props => (props.open ? '1' : '0')};
  transform: translateX(${props => (props.open ? '0' : '-100%')});
  transition: all ease-in-out 0.16s;
  border-top: 1px solid ${props => props.theme.colors.secondary[50]};

  &,
  * {
    pointer-events: ${props => (props.open ? 'auto' : 'none')};
  }
`

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  details {
    width: 100%;
    padding-inline: ${props => props.theme.spacing.medium};
    border-bottom: 1px solid ${props => props.theme.colors.secondary[50]};

    &[open] {
      background-color: ${props => props.theme.colors.secondary[25]};

      & > summary > div {
        transform: rotate(90deg);
      }
    }
  }

  summary {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${props => props.theme.colors.secondary[500]};
    text-align: left;
    padding-block: ${props => props.theme.spacing.medium};

    span {
      color: ${props => props.theme.colors.black[500]};
      font-weight: ${props => props.theme.fontWeight.medium};
      margin-left: ${props => props.theme.spacing.default};
    }

    div {
      margin-left: auto;
    }
  }

  section {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: ${props => props.theme.spacing.default};
    padding-bottom: ${props => props.theme.spacing.default};
  }
`

export const SubMenuButton = styled.button<{ active?: boolean }>`
  background-color: ${props => (props.active ? props.theme.colors.secondary[100] : 'transparent')};
  font-weight: ${props => props.theme.fontWeight.medium};
  padding-block: ${props => props.theme.spacing.medium};
  text-align: left;
  width: 100%;
`

export const MobileMenuFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
  width: 100%;
  padding: ${props => props.theme.spacing.large} 0;
`

export const UserInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.xlarge};
  justify-content: flex-start;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.colors.secondary[50]};
  border-top: 1px solid ${props => props.theme.colors.secondary[50]};
  background: linear-gradient(82.53deg, rgba(234, 234, 255, 0.5) -3.71%, rgba(255, 249, 246, 0.5) 107.15%);
`

export const UserName = styled.div`
  font-weight: ${props => props.theme.fontWeight.medium};
  margin-bottom: ${props => props.theme.spacing.small};
`
export const UserCompanyName = styled.div`
  color: #827c8d;
`
